import { createAsyncDisposable, createDisposable } from './disposable'

export const spawn = (fn: (stack: DisposableStack) => unknown, handleError?: (e: unknown) => unknown) => {
  const stack = new DisposableStack()

  void (async () => {
    try {
      await fn(stack)
    } catch (e) {
      try {
        stack.dispose()
      } catch {
        console.warn('Error during spawn disposal after failure', e)
      }
      try {
        handleError?.(e)
      } catch {
        console.warn('Error in spawn error handler', e)
      }
    }
  })()

  return createDisposable(() => {
    if (stack.disposed) return
    stack.dispose()
  })
}

export const spawnAsync = (fn: (stack: AsyncDisposableStack) => unknown, handleError?: (e: unknown) => unknown) => {
  const stack = new AsyncDisposableStack()
  void (async () => {
    try {
      await fn(stack)
    } catch (e) {
      try {
        await stack.disposeAsync()
      } catch {
        console.warn('Error during spawn disposal after failure', e)
      }
      try {
        handleError?.(e)
      } catch {
        console.warn('Error in spawn error handler', e)
      }
    }
  })()
  return createAsyncDisposable(async () => {
    if (stack.disposed) return
    await stack.disposeAsync()
  })
}
